const NEXT_ROUND = 'NEXT_ROUND';
const SET_ROUND_WIN_COMPUTER = 'SET_ROUND_WIN_COMPUTER';
const ZEROING_STATE_ROUND = 'ZEROING_STATE_ROUND';
const SET_ROUND_ONE = 'SET_ROUND_ONE';
const SET_ROUND_TWO = 'SET_ROUND_TWO';
const SET_ROUND_THREE = 'SET_ROUND_THREE';
const SET_ROUND_FOUR = 'SET_ROUND_FOUR';
const SET_ROUND_FIVE = 'SET_ROUND_FIVE';
const SET_ROUND_SIX = 'SET_ROUND_SIX';
const SET_ROUND_SEVEN = 'SET_ROUND_SEVEN';
const SET_ROUND_WIN_USER = 'SET_ROUND_WIN_USER';
const SET_CURRENT_SIMBOL_USER = 'SET_CURRENT_SIMBOL_USER';
const SET_CURRENT_SIMBOL_COMPUTER = 'SET_CURRENT_SIMBOL_COMPUTER';

export const nextRoundAction = (payload) => ({
  type: NEXT_ROUND,
  payload,
});

export const setRoundWinUserAction = (payload) => ({
  type: SET_ROUND_WIN_USER,
  payload,
});

export const setRoundWinComputerAction = (payload) => ({
  type: SET_ROUND_WIN_COMPUTER,
  payload,
});

export const setRoundOneAction = (payload) => ({
  type: SET_ROUND_ONE,
  payload,
});

export const setRoundTwoAction = (payload) => ({
  type: SET_ROUND_TWO,
  payload,
});

export const setRoundThreeAction = (payload) => ({
  type: SET_ROUND_THREE,
  payload,
});

export const setRoundFourAction = (payload) => ({
  type: SET_ROUND_FOUR,
  payload,
});

export const setRoundFiveAction = (payload) => ({
  type: SET_ROUND_FIVE,
  payload,
});

export const setRoundSixAction = (payload) => ({
  type: SET_ROUND_SIX,
  payload,
});

export const setRoundSevenAction = (payload) => ({
  type: SET_ROUND_SEVEN,
  payload,
});

export const setCurrentSimbolUserAction = (payload) => ({
  type: SET_CURRENT_SIMBOL_USER,
  payload,
});

export const setCurrentSimbolComputerAction = (payload) => ({
  type: SET_CURRENT_SIMBOL_COMPUTER,
  payload,
});

export const zeroingStateRoundAction = (payload) => ({
  type: ZEROING_STATE_ROUND,
  payload,
});
